$(document).ready(function(){
      $('.pure_test_slider').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        speed: 300,
        infinite: true,
        centerMode: true,
        autoplaySpeed: 2000,
        autoplay: true,        
        responsive: [      
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        }
      }
    ]
      });

$(window).resize(function(){
      if($(window).width() < 768) {
        $('.security_slide').slick({
           infinite: true,
           slidesToShow: 1,
           slidesToScroll: 1,
           arrows: true,
           autoplay: true,
           dots:false,
           autoplaySpeed: 2000,
           prevArrow:'<button class="slick-prev slick-arrow shop-prev" aria-label="Previous" type="button"><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75 1.5L1.25 9L8.75 16.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
           nextArrow:'<button class="slick-next slick-arrow shop-next" aria-label="Next" type="button"><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 16.5L8.75 9L1.25 1.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        });
      } else {
        $('.security_slide').unslick('unslick');
      }
    });
$('.multiple-items').slick({
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 2,
  prevArrow:'<button class="slick-prev slick-arrow multi-prev" aria-label="Previous" type="button"><svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_400_1112)"><rect width="52" height="52" rx="26" transform="matrix(-1 0 0 1 64 12)" fill="white"/></g><path d="M43 47.8574L33 38.4287L43 29" stroke="#12281F" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/><defs><filter id="filter0_d_400_1112" x="0" y="0" width="76" height="76" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset/><feGaussianBlur stdDeviation="6"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_400_1112"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_400_1112" result="shape"/></filter></defs></svg></button>',
  nextArrow:'<button class="slick-next slick-arrow multi-next" aria-label="Next" type="button"><svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_400_1108)"><rect x="12" y="12" width="52" height="52" rx="26" fill="white"/></g><path d="M33 47.8574L43 38.4287L33 29" stroke="#12281F" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/><defs><filter id="filter0_d_400_1108" x="0" y="0" width="76" height="76" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset/><feGaussianBlur stdDeviation="6"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_400_1108"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_400_1108" result="shape"/></filter></defs></svg></button>',       
});
// setTimeout(function() {
// $('.shopify-policy__container').addClass('page-width');
// }, 100);
 });
